export default "__VITE_ASSET__C$pO2e7r__"